"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog from "@/components/dialog/UiDialog.vue";
import US from "@/assets/img/flag_svg/united-states.svg";
import CHINA from "@/assets/img/flag_svg/china.svg";
import SPAIN from "@/assets/img/flag_svg/spain.svg";
const uuid = require("uuid");
let LanguageConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.old_language = "";
  }
  mounted() {
    return __async(this, null, function* () {
      let response = yield API.get(`api://base.local/system/locale`);
      if (response.data.locale === "zh-CN" || response.data.locale === "en-US" || response.data.locale === "es-ES") {
        this.$i18n.locale = response.data.locale;
        this.old_language = response.data.locale;
        document.documentElement.lang = response.data.locale;
        localStorage.setItem("lang", response.data.locale);
      } else {
        this.$i18n.locale = "zh-CN";
        document.documentElement.lang = "zh-CN";
        localStorage.setItem("lang", "zh-CN");
      }
    });
  }
  changeLang() {
    this._change_language_config.show();
  }
  changeLanguage(lang) {
    return __async(this, null, function* () {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      document.documentElement.lang = lang;
      yield API.put(`api://base.local/system/locale`, {
        "locale": lang
      });
    });
  }
  toRelaunch() {
    return __async(this, null, function* () {
      try {
      } catch (error) {
      }
    });
  }
};
__decorateClass([
  Ref("change-language-dialog")
], LanguageConfig.prototype, "_change_language_config", 2);
LanguageConfig = __decorateClass([
  Component({
    components: {
      UiDialog,
      US,
      CHINA,
      SPAIN
    }
  })
], LanguageConfig);
export {
  LanguageConfig as default
};
